import React from "react";

export default function CommentInput({
  comment,
  setComment,
  clientVisible,
  setClientVisible,
  clientView
}) {
  return (
    <div>
      <div className="row">
        <div className="col-md-10">
          <input
            type="text"
            className="form-control"
            placeholder="Add a comment here..."
            onChange={(e) => setComment(e.target.value)}
            value={comment}
            style={{ width: "100%" }}
          />
        </div>
        <div className="col-md-2">
          <button type="submit" className="btn btn-primary btn-block" style={{ marginLeft: "4px" }}>
            {I18n.t("add_comment")}
          </button>
        </div>
      </div>

      {!clientView && (
        <div className="row" style={{ marginTop: 10 }}>
          <div className="col-md-12">
            <label className="checkbox-inline">
              <input
                type="checkbox"
                onChange={(e) => setClientVisible(e.target.checked)}
                checked={clientVisible}
              />
              {I18n.t("client_visible")}
            </label>
          </div>
        </div>
      )}

      {!clientView && clientVisible && (
        <div className="alert alert-danger" style={{ marginTop: 15, marginBottom: 0 }}>
          {I18n.t("client_will_see_this_comment")}
        </div>
      )}
      {!clientView && !clientVisible && (
        <div className="alert alert-default" style={{ marginTop: 15, marginBottom: 0 }}>
          {I18n.t("only_lab_users_will_see_this_comment")}
        </div>
      )}
      {clientView && (
        <div className="alert alert-default" style={{ marginTop: 15, marginBottom: 0 }}>
          {I18n.t("client_comment_notice")}
        </div>
      )}
    </div>
  );
}
